import { useEffect, useState } from 'react';
import { APP_VERSION } from '../version.js';

// A cached index.html can keep an old bundle running for days, so the app
// checks whether the deployed build still matches the one it is running — on
// load, and every time it comes back to the foreground, which is when a phone
// app actually gets used again.
export default function UpdateBanner() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = await res.json();
        if (alive && version && version !== APP_VERSION) setStale(true);
      } catch { /* offline or blocked: nothing to say */ }
    };
    check();
    const onFocus = () => { if (!document.hidden) check(); };
    document.addEventListener('visibilitychange', onFocus);
    window.addEventListener('focus', onFocus);
    return () => {
      alive = false;
      document.removeEventListener('visibilitychange', onFocus);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  if (!stale) return null;
  return (
    <button className="updatebar" onClick={() => window.location.reload()}>
      Nuova versione disponibile · <b>aggiorna</b>
    </button>
  );
}
